module.exports = __webpack_public_path__ + "static/media/ploni-bold-aaa.53227a39.eot";